import { useEffect } from "react";
import HeaderImage from "../../assets/bgremove.png";
import HeaderImageTwo from "../../assets/ami.jpeg";
import CV from "../../assets/raisulislampaisu714.pdf";
import data from "./data";
import AOS from "aos";
import "aos/dist/aos.css";
import "./header.css";
import { Carousel } from "react-responsive-carousel";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";

import TimelineConnector from "@mui/lab/TimelineConnector";

const Header = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <header id="header">
      <div className="container header__container">
        <div className="header__profile" data-aos="fade-in">
          <div class="carousel-wrapper">
            <Carousel infiniteLoop useKeyboardArrows autoPlay>
              <div>
                <img src={HeaderImage} alt="" />
              </div>
              <div>
                <img src={HeaderImageTwo} alt="" />
              </div>
              <div>
                <img src={HeaderImage} alt="" />
              </div>
            </Carousel>
          </div>
        </div>
        <h3 data-aos="fade-up">Raisul Islam piaus</h3>
        <p data-aos="fade-up">
          Get ready to bring your dream website or mobile app to life with just
          a click! Whether you're envisioning a modern, mobile-responsive
          interface or a high-performing platform, I've got you covered. Share
          the details of your project, and let's create a stunning website that
          exceeds your expectations..
        </p>
        <div className="header__cta" data-aos="fade-up">
          <a href="#contact" className="btn primary">
            Let's Talk
          </a>
          <a href="#portfolio" className="btn light">
            My Work
          </a>
        </div>
        <div className="header__socials">
          {data.map((item) => (
            <a
              key={item.id}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.icon}
            </a>
          ))}

          <Timeline className="time">
            <TimelineItem>
              <TimelineConnector
                sx={{ flexGrow: 0, position: "relative", right: "38px" }}
              />
            </TimelineItem>
          </Timeline>
          <a href={CV}>
            <Timeline>
              <div className="newcv">CV</div>
            </Timeline>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
